module.exports = __webpack_public_path__ + "static/3-041ddaaf684997ef094cd1eb2118678f.jpg";